export const FEATURE_KEY_ICON_MAP = {
  WorkingHours: 'icon-alarm',
  Address: 'icon-flag',
  Town: 'icon-office'
};
